import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { FadeUp } from "@/components/motion-ui";

const testimonials = [
  {
    name: "Sandrine M.",
    role: "Cliente fidèle",
    text: "En 6 semaines avec la méthode BBL Natural Sculpt, j'ai retrouvé un corps de rêve sans bistouri. Perle est magique, énergique, bienveillante. La GigaFam m'a changé la vie.",
    color: "bg-pink-600",
  },
  {
    name: "Laetitia D.",
    role: "Programme anti burn-out",
    text: "J'étais cramée par le travail. Le programme anti burn-out m'a remis sur pied. J'ai retrouvé mon sommeil, ma joie et mon énergie tropicale 🌴",
    color: "bg-cyan-500",
  },
  {
    name: "Karine P.",
    role: "Drainage lymphatique",
    text: "Les drainages sont une bombe. Mes jambes ne gonflent plus, je me sens légère comme une plume. Et l'ambiance de l'institut est DINGUE.",
    color: "bg-amber-400 text-neutral-900",
  },
  {
    name: "Mélanie B.",
    role: "Élastiques LAGIGAFAM",
    text: "Les élastiques sont d'une qualité incroyable. Je m'entraîne à la maison avec les vidéos de Perle, mes fessiers et abdos n'ont jamais été aussi galbés.",
    color: "bg-fuchsia-600",
  },
];

export default function Testimonials() {
  return (
    <section
      id="temoignages"
      data-testid="testimonials-section"
      className="relative px-5 md:px-8 py-24 md:py-32 bg-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto">
        <FadeUp className="text-center mb-14">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] text-pink-600 mb-3">
            ✦ Témoignages
          </span>
          <h2 className="font-display text-4xl md:text-6xl font-black uppercase tracking-tight text-neutral-900 leading-[0.95]">
            Elles ont rejoint
            <br />
            la <span className="text-pink-600">GigaFam</span>.
          </h2>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t, i) => (
            <motion.article
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 0.8, 0.3, 1] }}
              whileHover={{ y: -8 }}
              className={`${t.color} text-white rounded-[1.8rem] p-7 flex flex-col h-full shadow-xl transition-transform duration-500`}
            >
              <Quote size={36} className="opacity-60 mb-4" />
              <p className="text-[15px] font-medium leading-relaxed flex-grow">
                "{t.text}"
              </p>
              <div className="mt-6 flex items-center gap-1 mb-2">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} fill="currentColor" />
                ))}
              </div>
              <p className="font-display text-xl font-black">{t.name}</p>
              <p className="text-xs font-bold uppercase tracking-widest opacity-80 mt-1">
                {t.role}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
